// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__NiOkC","header":"PatientQuestionnaire_header__3gDxo","info":"PatientQuestionnaire_info__1wNF8"};